export class Model {
  id!: number;

  get strId(): string {
    return String(this.id);
  }
}
